<template>
    <div>
        <div class="kgr-grid kgr-grid--gutters kgr-row">
            <div class="kgr-grid__cell">
                <div class="kgr-float kgr-float--left kgr-float--inText">
                    <div class="kgr-inputGroup">
                        <label class="kgr-inputGroup__label">{{ $t('Aktionstypen') }}</label>
                        <kgr-multi-select
                            v-model="chosenEventTypes"
                            :options="filteredEventTypes"
                            :inline="false"
                            @post-input="loadActionLogData"
                        />
                    </div>
                </div>
                <div class="kgr-float kgr-float--left kgr-float--inText">
                    <div class="kgr-inputGroup">
                        <label class="kgr-inputGroup__label">{{ $t('Startdatum') }}</label>
                        <kgr-date-picker
                            v-model="formattedStartDate"
                            :invalid="checkStartBeforeEndDate"
                        />
                        <div
                            v-if="checkStartBeforeEndDate"
                            class="kgr-inputGroup__text kgr-inputGroup__text--error"
                        >
                            {{ $t('Das Startdatum darf nicht nach dem Enddatum liegen.') }}
                        </div>
                    </div>
                </div>
                <div class="kgr-float kgr-float--left kgr-float--inText">
                    <div class="kgr-inputGroup">
                        <label class="kgr-inputGroup__label">{{ $t('Enddatum') }}</label>
                        <kgr-date-picker
                            v-model="formattedEndDate"
                        />
                    </div>
                </div>
                <div class="kgr-float kgr-float--left kgr-float--inText">
                    <div class="kgr-inputGroup">
                        <label class="kgr-inputGroup__label">{{ $t('Uhrzeit') }}</label>
                        <kgr-time-range-picker
                            :start="formattedStartTime"
                            :end="formattedEndTime"
                        />
                    </div>
                </div>
            </div>
        </div>

        <kgr-loader v-if="loading" />
        <div v-else>
            <kgr-empty-data
                v-if="logEntries.length === 0"
                :value="$t('Keine Ergebnisse für die ausgewählten Filter vorhanden.')"
            />
            <table
                v-else
                class="kgr-table kgr-table--striped kgr-table--block table-groups"
            >
                <thead>
                    <tr class="kgr-table__row">
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t('Datum') }}
                        </th>
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t('Uhrzeit') }}
                        </th>
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t('Aktion') }}
                        </th>
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t('Vorname') }}
                        </th>
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t('Nachname') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="logEntry in logEntries"
                        :key="logEntry.id"
                        class="kgr-table__row  kgr-table__row--top"
                    >
                        <td class="kgr-table__cell">
                            {{ logEntry.createdAtDate }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ logEntry.createdAtTime }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ $t('action.log.event.' + logEntry.event) }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ logEntry.createdByFirstName }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ logEntry.createdByLastName }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div
                v-if="logEntries.length > limit"
                class="kgr-alert kgr-alert--info"
            >
                {{ $t('Weitere Ergebnisse wurden ausgeblendet. Verwende die Filter, um die Suche einzuschränken.') }}
            </div>
        </div>
    </div>
</template>

<script>
import ClubActionLogRepository from '../../../js/repository/ClubActionLogRepository';
import DatePicker from '../../../components/common/form/picker/DatePicker.vue';
import EmptyData from '../../../components/common/EmptyData.vue';
import Loading from '../../../components/common/Loading.vue';
import MultiSelect from '../../../components/common/form/select/MultiSelect.vue';
import TimeRangePicker from '../../../components/common/form/picker/TimeRangePicker.vue';
import moment from 'moment/moment';

export default {

    components: {
        'kgr-loader': Loading,
        'kgr-empty-data': EmptyData,
        'kgr-date-picker': DatePicker,
        'kgr-multi-select': MultiSelect,
        'kgr-time-range-picker': TimeRangePicker,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            logEntries: [],
            limit: 50,
            loading: true,
            error: new Error(),
            dateTimeRange: {},
            eventTypes: [],
            chosenEventTypes: [],
        };
    },
    computed: {
        formattedStartDate: {
            get() {
                return this.dateTimeRange.start.format('DD.MM.YYYY');
            },
            set(newDate) {
                newDate = moment(newDate, 'DD.MM.YYYY');
                this.dateTimeRange.start = moment(this.dateTimeRange.start).set('date', newDate.date()).set('month', newDate.month()).set('year', newDate.year());
                this.loadActionLogData();
            }
        },
        formattedEndDate: {
            get() {
                return this.dateTimeRange.end.format('DD.MM.YYYY');
            },
            set(newDate) {
                newDate = moment(newDate, 'DD.MM.YYYY');
                this.dateTimeRange.end = moment(this.dateTimeRange.end).set('date', newDate.date()).set('month', newDate.month()).set('year', newDate.year());
                this.loadActionLogData();
            }
        },
        formattedStartTime() {
            return this.dateTimeRange.start.format('HH:mm');
        },
        formattedEndTime() {
            return this.dateTimeRange.end.format('HH:mm');
        },
        checkStartBeforeEndDate() {
            return moment(this.dateTimeRange.start).format('YYYY-MM-DD HH:mm:ss') > moment(this.dateTimeRange.end).format('YYYY-MM-DD HH:mm:ss');
        },
        filteredEventTypes() {
            return this.eventTypes.filter(type => {
                return this.chosenEventTypes.find(selectedType => type.value === selectedType.value) === undefined
            });
        },
        filter() {
            let filterTypes = [];
            this.chosenEventTypes.forEach(terminal => filterTypes.push(terminal.value));

            return {
                inDateTimeRange: { start: this.dateTimeRange.start.format('YYYY-MM-DD HH:mm:ss'), end: this.dateTimeRange.end.format('YYYY-MM-DD HH:mm:ss') },
                limit: this.limit,
                eventTypes: filterTypes,
            }
        },
    },
    mounted() {
        this.loadEventTypeData();
        this.loadActionLogData();
    },
    created() {
        this.dateTimeRange = {
            start: moment().startOf('month').startOf('date'),
            end: moment().endOf('date'),
        };
    },
    methods: {
        loadEventTypeData() {
            ClubActionLogRepository.findEventTypes(this.clubId)
                .then(response => {
                    response.forEach(type => this.eventTypes.push({'label': type.label, 'value': type.value}));
                })
                .catch(error => {
                    this.error = error;
                }).finally(() => {
                    this.loading = false;
                });
        },
        loadActionLogData() {
            if (this.checkStartBeforeEndDate) {
                return;
            }
            ClubActionLogRepository.findAll(this.clubId, this.filter)
                .then(response => {
                    this.logEntries = response;
                })
                .catch(error => {
                    this.error = error;
                }).finally(() => {
                    this.loading = false;
                });
        },
    },
}
</script>

<style lang="scss">

</style>
